import axios from '../util/axiosConfig';


export const fetchModalityAPI = async () => {
    return await axios.get('/api/v1/modality')
        .then(function (response) {
            if (response.data) {
                return { success: true, modalityTypes: response.data };
            } else {
                return { success: false }
            }
        }).catch(function (error) {
            return { success: false }
        })
}